module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_3_main-31766f4144a17f77bd2d2ba2c681d3f8.png";